import { render, staticRenderFns } from "./Perspective.vue?vue&type=template&id=bb31708e&"
import script from "./Perspective.vue?vue&type=script&lang=js&"
export * from "./Perspective.vue?vue&type=script&lang=js&"
import style0 from "./Perspective.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports